module.exports = __webpack_public_path__ + "static/media/challenge-background-done.34ffa918.svg";